import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { memo } from "react";
import ReactModal from "react-modal";

import Button from "components/Button";
import { Question } from "types/types";
import ReportPart2Modal from "./ReportPart2Modal";
import { useForm } from "react-hook-form";

const ReportPart1 = (question: Question) => {
  const modal = useModal();
  const { register, handleSubmit } = useForm<{ report: string }>();

  const closeModal = () => {
    modal.hide();
    modal.reject();
  };

  const onNext = ({ report }: { report: string }) => {
    closeModal();
    setTimeout(() => {
      NiceModal.show(ReportPart2Modal, { ...question, report });
    }, 100);
  };

  return (
    <ReactModal
      overlayClassName="overflow-auto flex fixed size-full top-0 left-0 z-30"
      className="bg-[rgba(0,0,0,0.2)] min-w-[1280px] min-h-[720px] pt-[10.125rem] pb-[3.5rem] flex justify-center items-start size-full outline-none"
      isOpen={modal.visible}
      onRequestClose={closeModal}
      onAfterClose={() => {
        modal.remove();
      }}
    >
      <main className="bg-white flex flex-col w-[50rem] p-[1.875rem] pt-[2.5rem] rounded-md outline-none">
        <header className="space-y-[0.625rem]">
          <h2 className="text-center font-bold text-24 leading-[1.375rem]">
            답변 신고
          </h2>
          <p className="text-center text-14">
            <strong className="text-primary font-bold">(1/2)</strong> 신고
            사유를 선택해주세요
          </p>
        </header>
        <section className="flex flex-col flex-1 overflow-hidden pt-[1.875rem] gap-[1.875rem]">
          <ul className="space-y-[0.625rem]">
            {[
              "질문과 관련 없는 답변이에요",
              "복사 붙여넣기를 했어요",
              "불성실한 답변이에요",
              "욕설/혐오/치별적인 발언이 속해있어요",
              "개인정보가 노출됐어요",
              "기타",
            ].map((label) => (
              <li key={label}>
                <label className="relative h-14 flex items-center px-[1.875rem]">
                  <span className="relative z-10">{label}</span>
                  <input
                    className="absolute w-0 h-0 opacity-0 cursor-pointer peer"
                    type="radio"
                    value={label}
                    {...register("report", { required: true })}
                  />
                  <span className="absolute inset-0 rounded-md border border-gray peer-checked:border-primary peer-checked:bg-[#E6EAFF]"></span>
                </label>
              </li>
            ))}
          </ul>
          <div className="flex justify-end gap-2">
            <Button className="w-[10.688rem]" outline onClick={closeModal}>
              취소
            </Button>
            <Button className="w-[10.688rem]" onClick={handleSubmit(onNext)}>
              다음
            </Button>
          </div>
        </section>
      </main>
    </ReactModal>
  );
};

const ReportPart1Modal = NiceModal.create(memo(ReportPart1));
ReportPart1Modal.displayName = "ReportPart1Modal";

export default ReportPart1Modal;
